<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Filter Options</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex>
    <form fxFlexFill>
      <app-options-card title="Filter By User" [options]="reportsService.extensionsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedExtensionOptions" [showSearchInput]="true"></app-options-card>
      <app-options-card title="Filter By Agent Group" [options]="reportsService.groupsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedGroupOptions" [showSearchInput]="true"></app-options-card>
      <app-options-card title="Filter By Hunt Group" [options]="reportsService.huntGroupsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedHuntGroupOptions" [showSearchInput]="true"></app-options-card>
      <app-options-card title="Filter By Department" [options]="reportsService.departmentsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedDepartmentOptions" [showSearchInput]="true"></app-options-card>
      <app-options-card title="Filter By Attendant" [options]="reportsService.attendantsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedAttendantsOptions" [showSearchInput]="true"></app-options-card>
      <app-card title="Filter By Phone Number" [collapsed]="false">
        <app-mat-phone-number-input [(ngModel)]="filterFromNumber" label="From Number"
                                    [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>

        <app-mat-phone-number-input [(ngModel)]="filterToNumber" label="To Number"
                                    [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>
      </app-card>
      <app-card title="Filter By Call Duration" [collapsed]="false">
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutGap.lt-md="5px">
          <app-duration-input label="Duration From" [(ngModel)]="filterDurationFrom"
                              [ngModelOptions]="{standalone: true}"></app-duration-input>
          <app-duration-input label="Duration To" [(ngModel)]="filterDurationTo"
                              [ngModelOptions]="{standalone: true}"></app-duration-input>
        </div>
      </app-card>
      <app-options-card title="Filter By Call Result" [options]="filterByStatusOptions"
                        [(checkedOptions)]="checkedStatusOptions"></app-options-card>
      <app-options-card title="Filter By Type" [collapsed]="false" [options]="filterByTypeOptions"
                        [(checkedOptions)]="checkedTypeOptions"></app-options-card>
      <app-options-card title="Do Not Include" [collapsed]="false" [options]="filterExcludeOptions"
                        [(checkedOptions)]="checkedExcludeOptions"></app-options-card>
      <app-options-card title="Filter By Companies" [options]="reportsService.domainsLookup" [collapsed]="false"
                        [(checkedOptions)]="checkedDomainOptions" [showSearchInput]="true"></app-options-card>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
  </mat-dialog-actions>
</div>
